import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const UgandaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16141'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16141)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 1.86667H20V0H0V1.86667Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33334H20V7.46667H0V9.33334Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 7.46663H20V4.66663H0V7.46663Z'
					fill='#ED1623'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.6667H20V1.8667H0V4.6667Z'
					fill='#FEE044'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V12.1333H0V14Z'
					fill='#ED1623'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 12.1334H20V9.33337H0V12.1334Z'
					fill='#FEE044'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99935 10.2666C11.8403 10.2666 13.3327 8.80407 13.3327 6.99994C13.3327 5.19581 11.8403 3.73328 9.99935 3.73328C8.1584 3.73328 6.66602 5.19581 6.66602 6.99994C6.66602 8.80407 8.1584 10.2666 9.99935 10.2666Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.28655 5.36671C9.15584 5.23861 9.15584 5.02814 9.28655 4.90004L9.50528 4.68569C9.51817 4.67306 9.52988 4.65952 9.54102 4.64533C9.55962 4.62164 9.59276 4.58107 9.63355 4.53817C9.7817 4.38236 10.2865 4.41437 10.4183 4.58421C10.4838 4.66849 10.4473 4.72488 10.3989 4.81991L10.0372 5.52867C10.0133 5.57558 10.0008 5.6275 10.0008 5.68016V5.85884C10.0008 5.98607 10.0733 6.10219 10.1875 6.15817L10.905 6.50973C10.9369 6.52539 10.9662 6.54607 10.9916 6.57099L11.7307 7.2953C11.8348 7.39729 11.8605 7.55506 11.7943 7.68486L11.6056 8.05475C11.5182 8.22597 11.2898 8.26326 11.1526 8.12873C11.0418 8.0202 10.8646 8.0202 10.7539 8.12873L10.5771 8.30202C10.5131 8.36471 10.477 8.45052 10.477 8.54009V8.76908C10.477 8.83152 10.5022 8.89134 10.5468 8.93504C10.6954 9.08074 10.5923 9.33338 10.3841 9.33338H10.0938C9.8856 9.33338 9.78244 9.08074 9.93111 8.93504C9.97571 8.89134 10.0008 8.83152 10.0008 8.76908V8.72865C10.0008 8.54716 9.85372 8.40004 9.67223 8.40004H9.66075C9.57351 8.40004 9.48975 8.43424 9.42744 8.4953L9.28174 8.63809C9.15215 8.76509 8.94477 8.76509 8.81517 8.63809C8.68182 8.5074 8.68182 8.29268 8.81517 8.162L8.95126 8.02863C9.01356 7.96757 9.09731 7.93338 9.18455 7.93338C9.48311 7.93338 9.63107 7.571 9.41783 7.36203L8.81519 6.77145C8.68183 6.64075 8.68183 6.426 8.8152 6.2953L9.28655 5.83338C9.41726 5.70528 9.41726 5.49481 9.28655 5.36671Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default UgandaFlagIcon;
